import styled from "styled-components";

export const Background = styled.div`
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 10px 0;
  background-color: #f0f0f0;
  box-sizing: border-box;
  -moz-box-sizing: border-box;

  @page {
    size: A4 portrait;
    margin: 1cm 1cm 2cm;
  }

  @page :first {
    margin-top: 0;
  }

  @media print {
    width: 210mm;
    height: 297mm;
  }
`;

export const Page = styled.div`
  width: 210mm;
  min-height: 297mm;
  padding: 5mm;
  margin: 10mm auto;
  background: white;

  @media print {
    margin: 0;
    border: none;
    border-radius: 0;
    box-shadow: none;
    page-break-after: always;
  }
`;

export const Subpage = styled.div`
  height: auto;
`;

export const Images = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 30px;

  img {
    &:nth-child(1) {
      height: 60px;
    }

    &:nth-child(2) {
      height: 40px;
    }
  }
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Title = styled.h1`
  font-size: 18px;
  text-align: center;
  padding: 12px 0 4px;
`;

export const Resume = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  font-size: 12px;
  font-weight: bold;
`;

export const Table = styled.table`
  font-size: 10px;
  width: 100%;
  text-align: center;
  margin: 16px 0;
  border-collapse: collapse;
  position: relative;

  thead {
    display: table-header-group;
  }

  tfoot {
    display: table-footer-group;
  }

  tr {
    page-break-inside: avoid;
  }

  th,
  td {
    border: 0.1px solid #000;
    padding: 5px;
    text-transform: uppercase;
    white-space: normal;
    word-break: break-word;
  }
`;
export const Button = styled.button`
  margin-right: 5px;
  width: 100px;
  height: 30px;
  border-radius: 4px;
  background: #2b74e0;
  color: #fff;
  border: 2px;
  outline: none;
  cursor: pointer;

  text-decoration: none;
  text-align: center;
  transition: linear 0.2s;
  &:hover {
    background-color: #1563cf;
  }

  @media print {
    display: none;
  }
`;
